/** Configuración compartida de la página listado de categoría (PLP). */
export const PLP_CONFIG = {
    PAGE_SIZE: 24,
    REQUESTS_PAGE_SIZE: 12,
    SCROLL_THRESHOLD: 0.5,
    REVALIDATE_TIME: 60,
    SCROLL_OFFSET: 80,
    ENABLE_VIDEO_GRID_4: true,
    ENABLE_VIDEO_GRID_7: false,
    DEFAULT_GRID_COLUMNS: 4 as 4 | 7,
    GRID_REFLOW_TIMEOUT: 300
} as const

export const SPECIAL_CATEGORIES = {
    GIFT_CARD: 'gift-card',
    GIFTCARD: 'giftcard'
} as const

/** Etiquetas de orden por defecto (alineadas con sortingLabels del API). */
export const SORT_LABELS = {
    price_asc: 'Menor precio',
    price_desc: 'Mayor precio',
    name: 'Nombre',
    new: 'Nuevo',
    saving: 'Mejor descuento',
    position: 'Recomendado'
} as const

/** Ajustes del carrusel de categorías en PLP (react-slick). */
export const SLIDER_SETTINGS = {
    DEFAULT_SLIDES_TO_SHOW: 4,
    LARGE_CATEGORY_SLIDES: 5,
    MOBILE_SLIDES_SMALL: 2,
    MOBILE_SLIDES_LARGE: 3,
    TABLET_SLIDES: 4
} as const
